module.exports = __webpack_public_path__ + "img/calendar-date-fill.fa023115.svg";